export const DISPLAYED_DATE_FORMAT = 'dd/MM/yyyy';

export const DISPLAYED_DATE_LENGTH = DISPLAYED_DATE_FORMAT.length;

export const IMPOSSIBLE_DATE_MESSAGE = "Cette date n'existe pas.";
